'use client';
import { useState } from 'react';

import { Card, CardContent } from '@/slw/shared/ui/card';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/slw/shared/ui/accordion';

export function SharingSocialFeatures() {
  const [open, setOpen] = useState(true);
  const triggerClass = 'md:pt-6 md:pb-4 py-4 text-sm md:text-base font-semibold leading-[100%] flex items-center';

  return (
    <Card className='rounded-2xl bg-[#F7F7F7] shadow-sm mb-8 border-0 p-6 md:p-8'>
      <div className='flex items-center justify-between'>
        <h3 className='text-xl md:text-[2rem] leading-[100%] font-bold text-foreground'>
          Sharing &amp; Social Features
        </h3>
        <button
          type='button'
          className='text-sm font-normal leading-[150%] text-muted-foreground hover:text-primary transition'
          onClick={() => setOpen((v) => !v)}
        >
          {open ? 'Hide' : 'Show'}
        </button>
      </div>
      {open && (
        <CardContent className='pt-0 px-0 pb-0 min-h-[40px]'>
          <CardContent className='pt-0 px-0 pb-0'>
            <Accordion type='multiple' className='divide-y divide-[#E5E5E5]'>
              <AccordionItem value='can-i-share-listings-with-friends'>
                <AccordionTrigger className={triggerClass}>Can I share listings with friends?</AccordionTrigger>
                <AccordionContent className='pl-0 text-sm leading-[150%]'>
                  Yes. Each listing has a “Share” button allowing you to email the listing or post to Facebook,
                  Instagram, or Twitter. You can also enter a friend’s email to send a personal recommendation.
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value='can-i-save-or-bookmark-cars-i-like'>
                <AccordionTrigger className={triggerClass}>Can I save or bookmark cars I like?</AccordionTrigger>
                <AccordionContent className='pl-0 text-sm leading-[150%]'>
                  Yes. Use the heart icon to save listings to your personal garage (account required).{' '}
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value='will-you-feature-my-car-on-social-media'>
                <AccordionTrigger className={triggerClass}>Will you feature my car on social media?</AccordionTrigger>
                <AccordionContent className='pl-0 text-sm leading-[150%]'>
                  Premium listings are eligible to be highlighted on our Instagram, Facebook, and email newsletter.
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </CardContent>
        </CardContent>
      )}
    </Card>
  );
}
